import {
  getKey,
  hasKey,
  isDataValid,
  isDefined,
  isFunction,
  logStdout,
  string2json,
  toNumber,
  unZip,
  isNewPupilCorneadia,
  getPupilCorneadiaKey
} from "../../../shared/utils";
import { iniReader } from "../../../fileoprators/iniReaderWriter";
import { INVALID_1000, MAJMEDIANMODES } from "../../../shared/consts";
import fileSys from "../../../fileoprators/fileSystem";
import { json2CSV, makeCSVpath, makeDir, mkdir } from "./funcs";
import { paramNormal } from "../../../shared/filters";
import { getAllRecordsOfPatientWithContent, getRecordContent } from "../../../services/record";
import { downloadCase } from "../../../topography/js/CaseHandle";
import { Topography3rd } from "../../../topography/js/thirdparty";
import ExportEyeJson from "../../../topography/js/exportEyeJson";
import ExportMwfXml from "../../../topography/js/exportMwfXml";
import { EventEmitter } from "eventemitter3";
//
/**
 * 根据设置返回数据
 * @param {string} data 需要转换的数字
 * @param {enum} mode 0.Q 1.P-VAL 2.E  3.ecc
 * @return {number}
 */
function calcMaj(v, mode = -1) {
  if (!isDataValid(v)) {
    return INVALID_1000;
  }
  let val = toNumber(v);
  switch (mode) {
    case MAJMEDIANMODES.Q:
      val = val - 1;
      break;
    case MAJMEDIANMODES.P:
      break;
    case MAJMEDIANMODES.E:
      val = 1 - val;
      break;
    case MAJMEDIANMODES.ecc:
      val = Math.sqrt(val > 1 ? 1 - 1 / val : 1 - val);
      break;
    default:
      break;
  }
  return val;
}
function normalEccEPQ(acANA, mode, mm) {
  if (!acANA || !acANA[this.section]) {
    return -1000;
  }
  const medians = {
    Inf: string2json(acANA[this.section].Inf) || [],
    Nas: string2json(acANA[this.section].Nas) || [],
    Sup: string2json(acANA[this.section].Sup) || [],
    Temp: string2json(acANA[this.section].Temp) || []
  };
  let maj = {
    Inf: [],
    Nas: [],
    Sup: [],
    Temp: []
  };
  Object.keys(medians).map((key) => {
    this.indexes.map((index) => {
      maj[key].push(calcMaj(medians[key][index], mode));
    });
  });
  let mean = [];
  this.indexes.map((index) => {
    let sum = -1000;
    let n = 0;
    Object.keys(maj).map((key) => {
      if (isDataValid(maj[key][index])) {
        if (sum === -1000) sum = 0;
        sum += maj[key][index];
        n += 1;
      }
    });
    mean.push(n === 0 ? -1000 : sum / n);
  });
  maj.Mean = mean;
  return mean[mm - 2];
}
function initTopoHeaders() {
  const keyValues = {
    info: {
      Name: { label: this.langcfg.txtName },
      PID: { label: this.langcfg.txtPID },
      Check_Time: { label: this.langcfg.txtCheckTime, key: "recorddate" },
      Eye: { label: this.langcfg.txtEye, key: "eyetype" }
    },
    params: {
      K1: { label: "K1", section: "CorneaFront", key: "K1" },
      K2: { label: "K2", section: "CorneaFront", key: "K2" },
      Rh: { label: "Rh", section: "CorneaFront", key: "Rh" },
      Rf: { label: "Rf", section: "CorneaFront", key: "Rf" },
      Km: { label: "Km", section: "CorneaFront", key: "Km" },
      Rm: { label: "Rm", section: "CorneaFront", key: "Rm" },
      Astig: { label: "Astig", section: "CorneaFront", key: "Astig" },
      Kmax: { label: "Kmax", section: "CorneaFront", key: "Kmax" },
      Rmin: { label: "Rmin", section: "CorneaFront", key: "Rmin" },
      RminX: { label: "RminX", section: "CorneaFront", key: "RminX" },
      RminY: { label: "RminY", section: "CorneaFront", key: "RminY" },

      Pupil_Diameter: { label: "Pupil_Diameter" },
      Corneal_Diameter: { label: "Corneal_Diameter" },
      Pupil_Diameter_dark: { label: "Pupil_Diameter_dark" },
      Pupil_Diameter_lowerMiddle: { label: "Pupil_Diameter_lowerMiddle" },
      Pupil_Diameter_middle: { label: "Pupil_Diameter_middle" },
      Pupil_Diameter_bright: { label: "Pupil_Diameter_bright" },

      ecc: {
        label: "ecc",
        suffix: this.dataShowSettings.mm + "mm",
        keys: ["Inf", "Nas", "Sup", "Temp"],
        section: "FrontpValOfMajMeridians",
        indexes: [0, 1, 2, 3, 4, 5, 6, 7, 8],
        mm: this.dataShowSettings.mm,
        func: function (acANA) {
          return normalEccEPQ.call(this, acANA, MAJMEDIANMODES.ecc, this.mm)._toFixed(2);
        }
      },
      E: {
        label: "E",
        keys: ["inf", "Nas", "Sup", "Temp"],
        suffix: this.dataShowSettings.mm + "mm",
        section: "FrontpValOfMajMeridians",
        indexes: [0, 1, 2, 3, 4, 5, 6, 7, 8],
        mm: this.dataShowSettings.mm,
        func: function (acANA) {
          return normalEccEPQ.call(this, acANA, MAJMEDIANMODES.E, this.mm)._toFixed(2);
        }
      },
      P: {
        label: "P",
        keys: ["inf", "Nas", "Sup", "Temp"],
        suffix: this.dataShowSettings.mm + "mm",
        section: "FrontpValOfMajMeridians",
        indexes: [0, 1, 2, 3, 4, 5, 6, 7, 8],
        mm: this.dataShowSettings.mm,
        func: function (acANA) {
          return normalEccEPQ.call(this, acANA, MAJMEDIANMODES.P, this.mm)._toFixed(2);
        }
      },
      Q: {
        label: "Q",
        keys: ["inf", "Nas", "Sup", "Temp"],
        section: "FrontpValOfMajMeridians",
        suffix: this.dataShowSettings.mm + "mm",
        mm: this.dataShowSettings.mm,
        indexes: [0, 1, 2, 3, 4, 5, 6, 7, 8],
        func: function (acANA) {
          return normalEccEPQ.call(this, acANA, MAJMEDIANMODES.Q, this.mm)._toFixed(2);
        }
      },
      SagCurv: {
        label: "Sag. Curv.",
        keys: ["inf", "Nas", "Sup", "Temp"],
        suffix: this.dataShowSettings.mm + "mm",
        mm: this.dataShowSettings.mm,
        indexes: [0, 1, 2, 3, 4, 5, 6, 7, 8],
        section: "FrontSagCurvOfMajMeridians",
        func: function (acANA) {
          return normalEccEPQ.call(this, acANA, MAJMEDIANMODES.SAGCURV, this.mm)._toFixed(2);
        }
      }
      // ,
      // CKI: { label: 'CKI', section: '8mmIndicespVal', key: 'CKI' },
      // IHD: { label: 'IHD', section: '8mmIndicespVal', key: 'IHD' },
      // IHA: { label: 'IHA', section: '8mmIndicespVal', key: 'IHA' },
      // ISV: { label: 'ISV', section: '8mmIndicespVal', key: 'ISV' },
      // IVA: { label: 'IVA', section: '8mmIndicespVal', key: 'IVA' },
      // KI: { label: 'KI', section: '8mmIndicespVal', key: 'KI' },
      // TCK: { label: 'TCK', section: '8mmIndicespVal', key: 'TCK' }
    }
  };
  let headers = [];
  for (let id in keyValues) {
    for (let idy in keyValues[id]) {
      headers.push(`${idy}${keyValues[id][idy].suffix ? "_" + keyValues[id][idy].suffix : ""}`);
    }
  }

  return { keyValues, headers };
}
function normalPatientName(patient) {
  return `${patient.firstname}${
    patient.lastname && patient.lastname !== "" ? " " + patient.lastname : ""
  }`.trim();
}
export default class ExportTopoAPI extends EventEmitter {
  constructor(storagePath, options, patients = [], unSelectedRecords = []) {
    super();
    this.storagePath = storagePath;
    this.folderName = options.folderName;
    this.exportOptions = options.exportOptions;
    this.dataShowSettings = options.dataShowSettings;
    this.patients = patients;
    this.unSelectedRecords = unSelectedRecords;
    this.langcfg = options.langcfg;
    this.topoHeaders = initTopoHeaders.call(this);
    this.csvData = [];
    this.isExporting = true;
    this.exportCount = 0;
  }
  stopExport() {
    this.isExporting = false;
  }
  normalCsvTable(patient, record, osod, casePath = "D:\\") {
    let acANAPath = fileSys.combinePath(casePath, "AC.ANA");
    const acANA = iniReader(acANAPath);

    let data = {};
    data.Name = normalPatientName(patient);
    data.PID = patient.pid;
    data.Eye = osod;
    data.Check_Time = record.recorddate;
    const { params } = this.topoHeaders.keyValues;
    for (let id in params) {
      if (id.indexOf("Pupil_Diameter") >= 0) {
        if (isNewPupilCorneadia(record, osod)) {
          let key = id.replace("Pupil_Diameter", "pupilcorneadia");

          if (key !== "pupilcorneadia") {
            if (hasKey(record, `content.data${osod}.${key}.pupildia.edge`)) {
              let val =
                record.content[`data${osod}`][key].pupildia.edge.r * window.magecoe.pupilcornea * 2;
              // console.log('---csvexport--- pupil new val ', val)
              data[id] = paramNormal(val);
            } else {
              data[id] = "--";
            }
          } else {
            delete data[id];
          }
        } else {
          if (id !== "Pupil_Diameter") {
            delete data[id];
          } else {
            if (hasKey(record, `content.data${osod}.pupilcorneadia.pupildia.edge`)) {
              let val =
                record.content[`data${osod}`].pupilcorneadia.pupildia.edge.r *
                window.magecoe.pupilcornea *
                2;
              // console.log('---csvexport--- pupil old val ', val)
              data[id] = paramNormal(val);
            } else {
              data[id] = "--";
            }
          }
          // this.topoHeaders.headers = this.topoHeaders.headers.filter(item => item !== ('Pupil_Diameter_dark'
          //   || 'Pupil_Diameter_lowerMiddle' || 'Pupil_Diameter_middle' || 'Pupil_Diameter_bright'
          // ))
        }
      }
      if (id === "Corneal_Diameter") {
        if (isNewPupilCorneadia(record, osod)) {
          if (hasKey(record, `content.data${osod}.pupilcorneadia_dark.corneadia.edge`)) {
            let val =
              record.content[`data${osod}`].pupilcorneadia_dark.corneadia.edge.r *
              window.magecoe.pupilcornea *
              2;
            // console.log('---csvexport--- cornea val ', val)
            data[id] = paramNormal(val);
          } else if (
            hasKey(record, `content.data${osod}.pupilcorneadia_lowerMiddle.corneadia.edge`)
          ) {
            let val =
              record.content[`data${osod}`].pupilcorneadia_lowerMiddle.corneadia.edge.r *
              window.magecoe.pupilcornea *
              2;
            // console.log('---csvexport--- cornea val ', val)
            data[id] = paramNormal(val);
          } else if (hasKey(record, `content.data${osod}.pupilcorneadia_middle.corneadia.edge`)) {
            let val =
              record.content[`data${osod}`].pupilcorneadia_middle.corneadia.edge.r *
              window.magecoe.pupilcornea *
              2;
            // console.log('---csvexport--- cornea val ', val)
            data[id] = paramNormal(val);
          } else if (hasKey(record, `content.data${osod}.pupilcorneadia_bright.corneadia.edge`)) {
            let val =
              record.content[`data${osod}`].pupilcorneadia_bright.corneadia.edge.r *
              window.magecoe.pupilcornea *
              2;
            // console.log('---csvexport--- cornea val ', val)
            data[id] = paramNormal(val);
          } else {
            data[id] = "--";
          }
        } else {
          if (hasKey(record, `content.data${osod}.pupilcorneadia.corneadia.edge`)) {
            let val =
              record.content[`data${osod}`].pupilcorneadia.corneadia.edge.r *
              window.magecoe.pupilcornea *
              2;
            // console.log('---csvexport--- cornea val ', val)
            data[id] = paramNormal(val);
          } else {
            data[id] = "--";
          }
        }
      }
      if (id === "Pupil_Diameter" || id === "Corneal_Diameter") {
        // if (isNewPupilCorneadia(record, osod)) {
        // } else {
        //   const pc = id === 'Pupil_Diameter' ? 'pupildia' : 'corneadia'
        //   if (hasKey(record, `content.data${osod}.pupilcorneadia.${pc}.edgeMoved`)) {
        //     let val = record.content[`data${osod}`].pupilcorneadia[pc].edgeMoved.r * window.magecoe.pupilcornea * 2
        //     console.log('---csvexport--- val ', val)
        //     data[id] = paramNormal(val)
        //   } else {
        //     data[id] = '--'
        //   }
        // }
      } else if (isFunction(params[id].func)) {
        const key = params[id].suffix ? `${id}_${params[id].suffix}` : id;
        data[key] = paramNormal(toNumber(params[id].func(acANA)));
      } else {
        const { section, key } = params[id];
        if (section && key) {
          if (hasKey(acANA, `${section}.${key}`)) {
            data[id] = paramNormal(toNumber(acANA[section][key]));
          } else {
            data[id] = "--";
          }
        }
      }
    }
    return data;
  }
  exportRecords(patient, records, callback) {
    if (records.length <= 0) {
      if (callback && this.isExporting) callback();
    } else {
      const record = records.pop();
      if (this.unSelectedRecords[record._id]) {
        if (this.isExporting) this.exportRecords(patient, records, callback);
      } else {
        this.exportOneTopograhy(patient, record, ["OS", "OD"], () => {
          if (this.isExporting) this.exportRecords(patient, records, callback);
        });
      }
    }
  }
  exportPatients(callback) {
    if (this.patients.length <= 0) {
      const { topocsv } = this.exportOptions.topography.children;
      if (topocsv && this.csvData.length > 0 && this.isExporting) {
        const csvPath = makeCSVpath(this.storagePath);
        json2CSV(this.topoHeaders.headers, this.csvData, csvPath);
        this.csvData = [];
        if (callback) callback(this.isExporting);
      } else {
        if (callback) callback(this.isExporting);
      }
    } else {
      const patient = this.patients.pop();
      getAllRecordsOfPatientWithContent(patient._id, { checktype: "topography" }, (res) => {
        if (res.message === "OK") {
          const { records } = res;
          if (!this.isExporting) return;
          this.exportRecords(patient, records.concat(), () => {
            fileSys.syncImmediate(() => {
              fileSys.clearCache(() => {
                if (this.isExporting) this.exportPatients(callback);
              });
            });
          });
        } else {
          if (this.isExporting) this.exportPatients(callback);
        }
      });
    }
  }
  exportOneTopograhy(patient, record, osods = ["OS", "OD"], callback) {
    if (osods.length <= 0) {
      this.emit("export-count", normalPatientName(patient) + "_" + record.recorddate);
      if (callback && this.isExporting) callback();
    } else {
      let osod = osods.pop();
      if (
        hasKey(record, `content.data${osod}.diagnosed`) &&
        record.content[`data${osod}`].diagnosed
      ) {
        const cases = getKey(record, `content.data${osod}.topography.photos`);
        let casePath = fileSys.getCasePath(`${record._id}_${osod}`);
        logStdout("export download case path:", casePath);
        if (!fileSys.isFileExists(casePath)) {
          if (cases && cases.length > 0 && cases[0].filename) {
            let zipPath = fileSys.getUploadPath(cases[0].filename);
            unZip(zipPath, casePath);
            logStdout("export download case path:", casePath);
          } else {
            if (this.isExporting) this.exportOneTopograhy(patient, record, osods, callback);
            return;
          }
        }

        const { topocsv, originalimage, map, dotEyeFile, dotMwfFile } =
          this.exportOptions.topography.children;
        logStdout("export originalimage topocsv enabled", topocsv);
        if (topocsv) {
          this.csvData.push(this.normalCsvTable(patient, record, osod, casePath));
        }
        if (originalimage || dotEyeFile || dotMwfFile) {
          const result = mkdir(
            this.folderName,
            this.storagePath,
            patient,
            record,
            osod,
            this.langcfg
          );
          if (result.message === "ok") {
            logStdout("export dot eyejson start", dotMwfFile);
            if (dotEyeFile && this.isExporting) {
              const exportEyeJson = new ExportEyeJson();

              exportEyeJson.addCTRecord(patient, record, casePath, osod);
              exportEyeJson.save(patient, result.path);
            }
            logStdout("export dotMwfFile start", dotMwfFile);
            if (dotMwfFile && this.isExporting) {
              const exportXML = new ExportMwfXml();
              exportXML.addCTRecord(patient, record, casePath, osod);
              exportXML.save(patient, result.path);
            }
            // console.log('export map start:', map)
            // if (map) {
            //   iscallback = false
            //   const topography = new Topography3rd(patient, record, casePath, osod)
            //   topography.normalFourMaps((maps) => {
            //     console.log('export map end:', maps)
            //     this.exportOneTopograhy(patient, record, osods, callback)
            //   }, result.path)
            // }
            if (originalimage && this.isExporting) {
              let photoPath = fileSys.combinePath(casePath, "original.jpg");
              let placidoPhotoPath = fileSys.combinePath(casePath, "placidoimage.jpg");
              let dstPhotoPath = fileSys.combinePath(result.path, "original.jpg");
              let dstplacidoPhotoPath = fileSys.combinePath(result.path, "placidoimage.jpg");

              fileSys.copyOneFileByPipe(photoPath, dstPhotoPath, () => {
                if (!this.isExporting) return;
                fileSys.copyOneFileByPipe(placidoPhotoPath, dstplacidoPhotoPath, () => {
                  if (this.isExporting) this.exportOneTopograhy(patient, record, osods, callback);
                });
              });
            } else {
              if (this.isExporting) this.exportOneTopograhy(patient, record, osods, callback);
            }
          } else {
            if (this.isExporting) this.exportOneTopograhy(patient, record, osods, callback);
          }
        } else {
          if (this.isExporting) this.exportOneTopograhy(patient, record, osods, callback);
        }
      } else {
        if (this.isExporting) this.exportOneTopograhy(patient, record, osods, callback);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mainInterface/components/exportData/exportTopoApi.js